<template>
    <vizit-one ref="softwareLicense" :url="url" @focusin="onFocus" @focusout="onFocusOut" />
</template>

<script setup lang="ts">
    import { Strings } from "@/locales/types/enums/strings";
    import { type Ref, ref, onBeforeUnmount, onMounted } from 'vue';
    import type { VizitOneRef } from "@/components/VizitOne/types";
    import { useRouter } from 'vue-router';
    import { linkItems } from "@/components/Header/types/LinkItemsCollection";
    import { useI18n } from "vue-i18n";

    const emit = defineEmits(['ready', 'start']);
    const { t } = useI18n();
    const router = useRouter();
    const { $navigator } = useNuxtApp();
    const url: string = t(Strings.SETTINGS_SOFTWARE_LICENSE_URL).toString();
    const softwareLicense: Ref<VizitOneRef | null> = ref(null);
    const isRegKeyListeners: Ref<boolean> = ref(false);

    const setSelfFocused = () => {
        if (softwareLicense.value) {
            softwareLicense.value.focusToCatcher();
        } 
        onFocus();
        emit("ready");
    };
    const unsetSelfFocused = () => {
        onFocusOut();
    };
    const registerKeyListeners = () => {
        if (!isRegKeyListeners.value) {
            $navigator.on("keypress:left", goToBack);
            $navigator.on("keypress:back", goToBack);
        }
    };
    const unregisterKeyListeners = () => {
        if (isRegKeyListeners.value) {
            $navigator.off("keypress:left", goToBack);
            $navigator.off("keypress:back", goToBack);
        }
    };
    const goToBack = () => {
        void router.push(linkItems.settings.routerPath);
    };
    const start = () => {
        emit("start");
    };

    start();

    const onFocus = () => {
        registerKeyListeners();
    };
    const onFocusOut = () => {
        unregisterKeyListeners();
    };

    onMounted(() => {
        setSelfFocused();
    });

    onBeforeUnmount(() => {
        unsetSelfFocused();
    });
</script>